module.exports = __webpack_public_path__ + "static/img/Stefano.0cf9363.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Stefano.jpg
// module id = wYGg
// module chunks = 0